'use client';

import {GradePanel} from 'iq-takehomes/components/grade_panel';
import {MySolutionPanel} from 'iq-takehomes/components/my_solution_panel';
import type {UserSolution} from 'iq-takehomes/types';
import {useState} from 'react';

type Props = {
  slug: string;
  mySolution: UserSolution | null;
};

// Shows the user's latest graded solution, with the option to grade a new one. Grading again
// just submits another solution — the backend stores each attempt as a separate row.
export function GradeSection({slug, mySolution}: Props) {
  const [resubmitting, setResubmitting] = useState(false);

  if (mySolution && !resubmitting) {
    return <MySolutionPanel solution={mySolution} slug={slug} onResubmit={() => setResubmitting(true)} />;
  }

  return <GradePanel slug={slug} onCancel={mySolution ? () => setResubmitting(false) : undefined} />;
}
